import isEmpty from 'lodash/isEmpty';
import { MESSAGETYPES, parseMessage } from 'conversional-iframe-communication';
import { CommonActions, ConfigActions, JourneysActions } from 'conversional-journey';
import { disableStorage, enableStorage } from 'conversional-persistent-storage';
// @ts-ignore
import * as updateJourneyConfigUtils from 'conversional-utils/updateJourneyConfig';
var env = process.env.REACT_APP_JOURNEY_ENV || 'development';
var onUpdateJourneyConfiguration = function (journeyConfig, key) {
    // update the journey config
    var mergedConfig = updateJourneyConfigUtils.updateJourneyConfig({
        config: journeyConfig,
        key: key,
    });
    // dispatch the action
    return JourneysActions.updateJourney(mergedConfig);
};
/**
 Provides a generic way to attach iframe messages to redux actions
 */
export var mapMessageToAction = function (message, _a) {
    var _b;
    var iframeId = _a.iframeId, resultId = _a.resultId, journeyId = _a.journeyId;
    // Only log in development and testing. Added because webpack could not strip it out in production
    if (['development', 'testing', 'remote'].includes(env)) {
        //eslint-disable-next-line no-console
        console.debug("%cchild ".concat(iframeId, " received message"), 'color: orange', message);
    }
    var _c = parseMessage(message), type = _c.type, payload = _c.payload;
    if (!type) {
        return;
    }
    var handlers = (_b = {},
        _b[MESSAGETYPES.SET_EXTERNAL] = function (data) { return ConfigActions.setExternal(data); },
        _b[MESSAGETYPES.RPC_SET_EXTERNAL] = function (data) {
            return ConfigActions.setExternal(data.payload);
        },
        // Only development purpose: Fine not to use local-storage-fallback
        _b[MESSAGETYPES.RPC_CLEAR_CACHE] = function () {
            localStorage.clear();
            sessionStorage.clear();
        },
        _b[MESSAGETYPES.JOURNEY_SHOW] = function (data) {
            data = (data === null || data === void 0 ? void 0 : data.isRPC) ? data.payload : data;
            return [
                ConfigActions.setExternal(isEmpty(data) ? { process: null } : data),
                JourneysActions.decideJourneyOpen({
                    journeyId: journeyId,
                    resultId: resultId,
                    iframeId: iframeId,
                }),
            ];
        },
        _b[MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_THEME] = function (data) {
            return onUpdateJourneyConfiguration(data.payload, 'theme');
        },
        _b[MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_CTA] = function (data) {
            return onUpdateJourneyConfiguration(data.payload, 'cta');
        },
        _b[MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_ENTRY] = function (data) {
            return onUpdateJourneyConfiguration(data.payload, 'entry');
        },
        _b[MESSAGETYPES.SET_SHARED_STORE] = function (data) { return CommonActions.setSharedStore(data); },
        _b[MESSAGETYPES.STORAGE_CONSENT_DEACTIVATE] = function () {
            disableStorage();
        },
        _b[MESSAGETYPES.STORAGE_CONSENT_ACTIVATE] = function () {
            enableStorage();
        },
        _b);
    var handler = handlers[type] || null;
    return handler ? handler(payload) : undefined;
};
